

































































































































































































































import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class MenuSmAndDown extends Vue {
  drawer = false;
}
